import React from 'react';

import { useAuthContext } from '../Core';
import { FullPageSpinner } from './FullPageSpinner';

const loadPostAuthenticationApp = () => import('./PostAuthenticationApp');
const AuthenticatedApp = React.lazy(loadPostAuthenticationApp);
const LoginApp = React.lazy(() => import('./PreAuthenticationApp'));

const Loader = () => {
  return <FullPageSpinner />;
};

const App = () => {
  const authContext = useAuthContext();

  React.useEffect(() => {
    loadPostAuthenticationApp();
  }, []);

  return (
    <React.Suspense fallback={<Loader />}>
      {authContext.userData && authContext.userData.accessToken ? (
        <AuthenticatedApp />
      ) : (
        <LoginApp />
      )}
    </React.Suspense>
  );
};

export default App;
